import {Routes} from '@angular/router';

import {ErrorComponent} from '@layouts/error/error.component';

export const errorRoute: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'pmweb',
    },
  },
  {
    path: 'accessdenied',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'pmweb',
      error403: true,
    },
  },
];
